<template>
  <div class="container">
    <div class="row align-items-center flex-column-reverse flex-md-row">
      <div class="col-12 col-md-6">
        <div class="">
          <h5 class="text-center mb-3 text-black-50">How I grow as web developer</h5>
          <div class="container d-flex justify-content-center">
            <ul class="p-0 w-100">
              <li class="rounded shadow mt-3 path-text-left">
                <span></span>
                <div class="w-100">
                  <p class="text-nowrap">Very first things I've learnt</p>
                  <div class="d-flex mt-3 align-items-center">
                    <img src="../assets/photo/path/html.svg" class="icon ms-3 h6" alt="" />
                    <img src="../assets/photo/path/css-3.svg" class="icon ms-3 h6" alt="" />
                    <img src="../assets/photo/path/javascript.svg" class="icon ms-3 h6" alt="" />
                    <img src="../assets/photo/path/adobe-xd.svg" class="icon ms-3 h6" alt="" />
                  </div>
                </div>
              </li>
              <li class="rounded shadow mt-3 path-text-left">
                <span></span>
                <div class="w-100">
                  <p class="">PHP as backend language and MySQL for database system,firebase for SPA</p>
                  <div class="d-flex mt-3 align-items-center">
                    <img src="../assets/photo/path/php.svg" class="icon ms-3" alt="" />
                    <img src="../assets/photo/path/mysql.svg" class="icon ms-3" alt="" />
                    <img src="../assets/photo/path/firebase.svg" class="icon ms-3" alt="" />
                  </div>
                </div>
              </li>
              <li class="rounded shadow mt-3 path-text-left">
                <span></span>
                <div class="w-100">
                  <p class="">Some frameworks for faster work flow and newer web apps</p>
                  <div class="d-flex mt-3 align-items-center">
                    <img src="../assets/photo/path/bootstrap-5.svg" class="icon ms-3" alt="" />
                    <img src="../assets/photo/path/inertia.png" class="icon ms-3" alt="" />
                    <img src="../assets/photo/path/laravel.svg" class="icon ms-3" alt="" />
                    <img src="../assets/photo/path/vue.svg" class="icon ms-3" alt="" />
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 path-text">
        <div>
          <h3 class="fw-bold">I'm strong in these areas</h3>
          <div class="card shadow blur-light my-3">
            <div class="card-body">
              <p class="p-0 p-md-3">I chose to become a Full-Stack web developer and so I've learned from scratch. The following tech stacks are trendy and I was used to those stacks.</p>
              <div class="d-flex w-75 justify-content-evenly align-items-center">
                <img src="../assets/photo/path/javascript.svg" class="icon ms-3" alt="" />
                <img src="../assets/photo/path/laravel.svg" class="icon ms-3" alt="" />
                <img src="../assets/photo/path/vue.svg" class="icon ms-3" alt="" />
                <img src="../assets/photo/path/inertia.png" class="icon ms-3" alt="" />
                <img src="../assets/photo/path/mysql.svg" class="icon ms-3" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  setup() {
    return {};
  },
};
</script>

<style scoped>
.container ul {
  margin: 0;
  list-style: none;
  position: relative;
}

.container ul li {
  position: relative;
  margin-left: 30px;
  background-color: rgba(255, 255, 255, 0.2);
  padding: 14px;
  border-radius: 6px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.12), 0 2px 2px rgba(0, 0, 0, 0.08);
}
.container ul li > span {
  width: 2px;
  height: 100%;
  background: #fff;
  left: -30px;
  top: 0;
  position: absolute;
}
.container ul li > span:before {
  content: "";
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 2px solid #fff;
  position: absolute;
  background: #414cd8;
  left: -5px;
  top: 0;
}
.container ul li span:after {
  top: 100%;
}
.container ul li > div {
  margin-left: 10px;
}
.container div .title,
.container div .type {
  font-weight: 600;
  font-size: 12px;
}
.container div .info {
  font-weight: 300;
}
.container div > div {
  margin-top: 5px;
}
.container span.number {
  height: 100%;
}
.container span.number span {
  position: absolute;
  font-size: 10px;
  left: -35px;
  font-weight: bold;
}
.container span.number span:first-child {
  top: 0;
}
.container span.number span:last-child {
  top: 100%;
}
</style>
